import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import pick from 'lodash/pick';

import { User } from 'Shared/constants/types';
import { getActionItems } from 'Shared/selectors/meetingItems';
import { useDeepEqualSelector } from 'Shared/utils/hooks';
import UserDataContainer from 'Shared/components/UserDataContainer/UserDataContainer';
import { getSortedItems } from 'Shared/utils/sorting';
import ActionItemsTable from 'Shared/components/ActionItems/ActionItemsTable/ActionItemsTable';
import { createItemFromSourceItemAction } from 'Shared/actions/meetingItems';

type Props = {
  user: User;
};

const sortingMap = {
  actionItems: 'default',
  owner: 'default',
  workspace: 'default',
  dueDate: 'ascending',
};

const ItemWhiteList = Object.freeze([
  'id',
  'uuid',
  'parentUuid',
  'workspacePath',
  'parentText',
  'isHighPriority',
  'workspaceId',
  'assignmentAvatar',
  'positionForActionItemsPage',
]);

const TeamUserOpenItems = ({ user }: Props) => {
  const dispatch = useDispatch();
  const [selectedSort, setSelectedSort] = useState(sortingMap);
  const actionItems = useDeepEqualSelector(state =>
    getSortedItems({
      items: getActionItems(state).filter(
        ({ assignmentPersonId, completed }) => assignmentPersonId === user.personId && !completed
      ),
      selectedSort,
      withHighPriority: true,
      positionField: 'positionForActionItemsPage',
    }).map(actionItem => pick(actionItem, ItemWhiteList))
  );

  const handleCreateItem = useCallback(
    ({ sourceItemUuid, itemUuid }) =>
      dispatch(
        createItemFromSourceItemAction({
          sourceItemUuid,
          itemUuid,
          positionField: 'positionForActionItemsPage',
          isAssignCurrentUser: false,
        })
      ),
    [dispatch]
  );

  if (!actionItems?.length) return null;

  return (
    <UserDataContainer user={user}>
      <div className="mt-2">
        <ActionItemsTable
          forbidDrag
          actionItems={actionItems}
          selectedSort={selectedSort}
          setSelectedSort={setSelectedSort}
          onCreateItem={handleCreateItem}
        />
      </div>
    </UserDataContainer>
  );
};

export default TeamUserOpenItems;
